import { useState } from 'react'
import { X } from 'lucide-react'
import { Button } from '@/components/ui/button'

interface KycRejectModalProps {
  driverName: string
  onConfirm: (reason: string) => void
  onCancel: () => void
  isPending: boolean
}

export default function KycRejectModal({
  driverName,
  onConfirm,
  onCancel,
  isPending,
}: KycRejectModalProps) {
  const [reason, setReason] = useState('')
  const isValid = reason.trim().length >= 10 && reason.trim().length <= 500

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-ink/55">
      <div className="bg-surface rounded-[20px] shadow-2xl w-[480px] max-w-[92vw] p-[26px]">
        <div className="flex items-center gap-3">
          <div className="w-11 h-11 rounded-xl bg-danger/[0.12] flex items-center justify-center shrink-0">
            <X size={22} strokeWidth={2.6} className="text-danger" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="font-display font-bold text-[19px] text-ink tracking-tight">
              Rejeter le dossier
            </div>
            <div className="text-[13px] text-muted mt-px truncate">{driverName}</div>
          </div>
          <button
            onClick={onCancel}
            disabled={isPending}
            className="text-muted hover:text-ink"
            aria-label="Fermer"
          >
            <X size={20} />
          </button>
        </div>

        <div className="text-[11px] font-semibold uppercase tracking-wide text-muted mt-[22px] mb-2">
          Motif du refus · obligatoire
        </div>
        <textarea
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          rows={4}
          maxLength={500}
          autoFocus
          placeholder="Ex : Photo de la CIN illisible — reflets. Merci de re-téléverser un scan net."
          className="w-full rounded-[14px] border-2 border-ink bg-bg p-4 text-sm text-ink focus:outline-none resize-none"
        />
        <div className="flex justify-between mt-2">
          <span className="text-[11.5px] text-muted">
            Le motif est envoyé au chauffeur par notification.
          </span>
          <span className="font-mono text-[11.5px] text-muted">{reason.length} / 500</span>
        </div>

        <div className="flex gap-3 mt-[22px]">
          <Button
            variant="outline"
            className="flex-1 h-12 rounded-button"
            onClick={onCancel}
            disabled={isPending}
          >
            Annuler
          </Button>
          <button
            onClick={() => onConfirm(reason.trim())}
            disabled={!isValid || isPending}
            className="flex-[1.3] inline-flex items-center justify-center gap-2 bg-danger text-white rounded-button h-12 text-sm font-semibold disabled:opacity-40 transition-opacity hover:opacity-90"
          >
            <X size={18} strokeWidth={2.4} />
            {isPending ? 'Envoi…' : 'Confirmer le rejet'}
          </button>
        </div>
      </div>
    </div>
  )
}
